module.exports = __webpack_public_path__ + "static/media/selfie-doodle@2x.63c8a77c.png";